import { css } from '@emotion/react';
import { media } from '@utex/ui-kit';

export const button = css`
  align-self: flex-end;
  margin-top: 1rem;

  @media ${media.phonablet} {
    align-self: center;
  }
`;
